import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Flex, Form, FormProps, Input } from 'antd';
import { SelectProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import CompanyContactInfoModal from '@/components/general/CompanyContactInfoModal';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

interface ShipmentPaymentFormProps {
  formProps: FormProps;
  companySelectProps: SelectProps;
  edit?: boolean;
}

const ShipmentPaymentForm = (props: ShipmentPaymentFormProps) => {
  const { t } = useTranslation();
  const { companyRepository } = useRepositoriesContext();
  const { formProps, companySelectProps } = props;
  const paymentCompany = Form.useWatch('shipment_payment_company', formProps.form);

  return (
    <div className="ShipmentFormRow">
      <Form.Item label={t('Razón social')} required>
        <Flex align="center" gap={4}>
          <Form.Item
            name={'shipment_payment_company'}
            rules={[
              {
                required: true,
                message: t('La razón social es requerida'),
              },
              {
                warningOnly: true,
                validator: async (_, value) => {
                  if (!value) return Promise.resolve();

                  const contacts = await companyRepository.getCompanyContact(value);

                  if (contacts.length === 0) {
                    return Promise.reject(new Error(t('La empresa no tiene un contacto asignado')));
                  }

                  return Promise.resolve();
                },
              },
            ]}
            noStyle>
            {/* <CompanySelector
              showFullName
              {...companySelectProps}
              style={{ width: '100%' }}
              allowClear
              showSearch
              onChange={(v, opt) => {
                companySelectProps?.onChange?.(v, opt);
                formProps.form?.setFieldValue(
                  'shipment_payment_cuit',
                  (opt as any)?.item?.cuit || '',
                );
                formProps.form?.setFieldValue('company', v);
                formProps.form?.setFieldValue('shipment_cuit', (opt as any)?.item?.cuit || '');
              }}
            /> */}
            <AntdSelect
              {...companySelectProps}
              style={{ width: '100%' }}
              allowClear
              showSearch
              onChange={(v, opt) => {
                companySelectProps?.onChange?.(v, opt);
                const cuit = Array.isArray(opt) ? '' : opt?.item?.cuit || '';

                formProps.form?.setFieldValue('shipment_payment_cuit', cuit);
                formProps.form?.setFieldValue('company', v);
                formProps.form?.setFieldValue('shipment_cuit', cuit);
              }}
            />
          </Form.Item>
          {paymentCompany && (
            <CompanyContactInfoModal
              company={paymentCompany}
              openButton={<Button icon={<InfoCircleOutlined />} />}
            />
          )}
        </Flex>
      </Form.Item>

      <Form.Item
        label={'CUIT'}
        name={'shipment_payment_cuit'}
        rules={[
          {
            required: true,
            message: t('El CUIT es requerido'),
          },
        ]}>
        <Input />
      </Form.Item>
    </div>
  );
};

export default ShipmentPaymentForm;
